import React from 'react';

import { get, camelCase } from 'lodash';
import PropTypes from 'prop-types';

import { useServerErrorState, useServerErrorActions } from 'contexts/ServerErrorContext';

export const withFormValidation =
  Component =>
  ({ formId = '', handleChange, validators = [], additionalValidators = [], ...props }) => {
    const fieldName = get(props, 'fieldName', '');
    const serverErrors = get(useServerErrorState(), camelCase(`${formId}${fieldName}`), []);
    const serverError = serverErrors.join('; ');
    const { resetServerFormError } = useServerErrorActions();

    const onChange = ({ target: { value } }) => {
      resetServerFormError(fieldName);
      handleChange({ [fieldName]: value });
    };

    const getValidators = () => [
      ...validators.map(validator => validator.rule),
      ...additionalValidators.map(validator => validator.rule),
    ];
    const getMessages = () => [
      ...validators.map(validator => validator.message),
      ...additionalValidators.map(validator => validator.message),
    ];

    return (
      <Component
        {...props}
        serverError={serverError}
        onChange={onChange}
        validators={getValidators()}
        errorMessages={getMessages()}
      />
    );
  };

export const withFormValidationPropTypes = {
  serverError: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  validators: PropTypes.arrayOf(PropTypes.string).isRequired,
  errorMessages: PropTypes.arrayOf(PropTypes.string).isRequired,
};
